"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unavailableErrors = exports.spinsOptions = exports.options = exports.exactMatchOptions = void 0;
const options = exports.options = {
  privateLabelId: 1,
  showFreeIndicator: false,
  showSldFirst: false,
  enableHover: false,
  enableFavorites: false,
  showSpinsSolutionSet: false,
  spinsHeader: {
    showSpinsHeader: false,
    showOfferNotQualified: false,
    lpHeadline: false,
    searchStatus: 'taken',
    headerOverrideTextId: null
  },
  exactMatchDomain: {
    IsAvailable: false,
    AvailabilityLabel: 'taken',
    IsDbsAvailable: true,
    IsPurchasable: true
  }
};
const exactMatchOptions = exports.exactMatchOptions = {
  ...options,
  tldTitle: 'exactResults.heading.allEndings',
  sldTitle: 'exactResults.heading.moreNames',
  spinsPerPage: 1,
  maxSpins: 1,
  tagsAndInfo: {
    exactTagTextId: 'Exact Match'
  },
  isListPricePriority: false,
  hideDetailedViewExactMatch: false
};
const spinsOptions = exports.spinsOptions = {
  ...options,
  tldTitle: 'spinResults.heading.allEndings',
  sldTitle: 'spinResults.heading.moreNames',
  isListPricePriority: true,
  hideDetailedViewExactMatch: true,
  tagsAndInfo: {
    adTagId: 'promoted',
    getDomainValuationUrl: () => 'https://godaddy.com',
    trendingTags: {
      us: [{
        text: 'Restricted',
        color: 'bg-dark'
      }]
    }
  }
};
const unavailableErrors = exports.unavailableErrors = {
  Unsupported: 'tld_unsupported',
  CharacterInvalid: 'character_invalid',
  IdnError: 'us_idn_not_allowed',
  LanguageUnsupported: 'language_unsupported',
  PunycodeError: 'punycode_conversion_error',
  TldInvalid: 'tld_invalid',
  SmartDefaultTld: 'smart_default_tld'
};